export default "__VITE_ASSET__Be$$Y8_S__"